import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {
      certificationMobile: '',
      roleId: null,
      careFirstOrderMedia: null,
      vinuxId: '',
      avatar: '',
      roleType: null,
      userName: '',
      userId: null,
      loginName: '',
      nickname: '',
      roleName: '',
      firstOrder: null,
      userType: null,
      sellerType: null,
      token: ''
    }
  },
  mutations: {
    SET_USERINFO: (state, payload) => {
      state.userInfo = payload
    },
    LOG_OUT: (state, payload) => {
      state.userInfo = {
        certificationMobile: '',
        roleId: null,
        careFirstOrderMedia: null,
        vinuxId: '',
        avatar: '',
        roleType: null,
        userName: '',
        userId: null,
        loginName: '',
        nickname: '',
        roleName: '',
        firstOrder: null,
        userType: null,
        sellerType: null,
        token: ''
      }
    }
  },
  actions: {
    setUserInfo ({commit}, payload) {
      commit('SET_USERINFO', payload)
    },
    doLogout ({commit}, payload) {
      commit('LOG_OUT', payload)
    }
  },
  getters: {
    isLogined: state => {
      if (state.userInfo.userId != null &&
        state.userInfo.token != null &&
        state.userInfo.token !== undefined &&
        state.userInfo.token.length > 2) {
        return true
      }
      return false
    }
  },
  modules: {}
})

// {
//   "certificationMobile": "18285195471",
//   "roleId": 15,
//   "careFirstOrderMedia": 202134,
//   "vinuxId": "2020061811515804937",
//   "avatar": "default-head.jpg",
//   "roleType": 120201,
//   "userName": "Test20200618",
//   "userId": 204573,
//   "loginName": "Test20200618",
//   "nickname": "Test20200618",
//   "roleName": "vinuxconsumer",
//   "firstOrder": null,
//   "userType": 120201,
//   "sellerType": null
// }



// WEBPACK FOOTER //
// ./src/store/index.js